import { useEffect, useRef, useMemo } from 'react';
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import { useSelector } from 'react-redux';
import { useTabBarFuncs } from '../../../hooks/responsive/useTabBarFuncs';
import { isNil } from 'lodash';
import { getTabsConfig } from '../../../constants';
import { getUrlQueryParam } from '../../../common/url';

const tabletStyle = {
  position: 'relative',
  width: '100%',
  height: '100dvh',
  backgroundImage: 'url("/theme/img/background/menu-toolbar.svg")',
  backgroundSize: '80%',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right center',
};

export function TabBar() {
  const { isReview, isShowSharing, activeTabBarId } = useSelector((state) => state.ui);
  const swiperRef = useRef(null);

  const { handleClick, handleActiveIndexChanged } = useTabBarFuncs(swiperRef);
  
  // Get fullCustom from URL query parameter
  const fullCustom = getUrlQueryParam('fullCustom');
  const TABS_CONFIG = useMemo(() => getTabsConfig(fullCustom), [fullCustom]);

  useEffect(() => {
    const item = TABS_CONFIG.find((e) => e.fcID === activeTabBarId);
    const index = TABS_CONFIG.findIndex((e) => e.fcID === activeTabBarId);
    if (isNil(item) || index < 0) return;
    console.log('activeTabBarId', activeTabBarId);
    handleClick(item, index);
  }, [TABS_CONFIG, activeTabBarId, handleClick]);

  return (
    !isReview &&
    !isShowSharing && (
      <div id="background-canvas" style={tabletStyle}>
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: '100%',
          }}
        >
          <SwiperComponent
            direction={'vertical'}
            slidesPerView={5}
            watchSlidesProgress={true}
            ref={swiperRef}
            onInit={(swiper) => {
              swiperRef.current = swiper;
            }}
            onSlideChange={(swiper) => {
              if (swiper.swipeDirection) {
                // "next" or "prev" if user swiped
                console.log('User swiped to index:', swiper.activeIndex);
                handleActiveIndexChanged(TABS_CONFIG[swiper.realIndex]?.fcID);
              }
            }}
            onProgress={(swiper) => {
              const slides = swiper.slides;

              for (const slide of slides) {
                const progress = slide.progress;
                const absProgress = Math.abs(progress);

                // Opacity decreases further from the center
                const opacity = Math.max(0, 1 - absProgress * 0.25);
                slide.style.opacity = `${opacity}`;

                const roundedProgress = Math.round(progress);
                if (roundedProgress === 0) {
                  slide.style.transform = `rotate(${0}deg) translateX(${12}%`;
                } else if (roundedProgress < 0) {
                  slide.style.transform = `rotate(${-5}deg) translateX(${-roundedProgress * 20}%)`;
                } else {
                  slide.style.transform = `rotate(${5}deg) translateX(${roundedProgress * 20}%)`;
                }
              }
            }}
            onSetTransition={(swiper, duration) => {
              for (const slide of swiper.slides) {
                slide.style.transitionDuration = `${duration}ms`;
              }
            }}
            centeredSlides={true}
            loop={true}
            modules={[Pagination, Navigation]}
            style={{
              width: '100%',
              height: '100%',
              paddingTop: '25%',
              paddingBottom: '25%',
              boxSizing: 'border-box',
            }}
          >
            {TABS_CONFIG?.map((item, index) => (
              <SwiperSlide key={`${item.fcID}-${item.id}-${index}`} style={{ display: 'flex' }}>
                <div
                  key={item.id}
                  className="item"
                  onClick={() => {
                    handleClick(item, index);
                  }}
                  style={{
                    backgroundImage: 'url(/theme/img/bgIcon.png)',
                    margin: 'auto',
                  }}
                >
                  <img src={item.logo} alt={`iconLogo${index + 1}`} width={30}></img>
                </div>
              </SwiperSlide>
            ))}
          </SwiperComponent>
        </div>
      </div>
    )
  );
}
